@if (model$ | async; as model) {
  <formly-form [form]="form" [fields]="fields" [options]="options" [model]="model"></formly-form>
}
